var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapsibleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5914 0.341713C11.514 0.263606 11.4218 0.201611 11.3202 0.159304C11.2187 0.116996 11.1098 0.0952148 10.9998 0.0952148C10.8898 0.0952148 10.7808 0.116996 10.6793 0.159304C10.5777 0.201611 10.4856 0.263606 10.4081 0.341713L6.59143 4.15837C6.51396 4.23648 6.4218 4.29847 6.32025 4.34078C6.2187 4.38309 6.10978 4.40487 5.99977 4.40487C5.88976 4.40487 5.78083 4.38309 5.67929 4.34078C5.57774 4.29847 5.48557 4.23648 5.4081 4.15837L1.59143 0.341713C1.51396 0.263606 1.4218 0.201611 1.32025 0.159304C1.2187 0.116996 1.10978 0.0952148 0.999765 0.0952148C0.889755 0.0952148 0.780834 0.116996 0.679285 0.159304C0.577735 0.201611 0.485568 0.263606 0.408099 0.341713C0.252889 0.497848 0.165771 0.709057 0.165771 0.929212C0.165771 1.14937 0.252889 1.36058 0.408099 1.51671L4.2331 5.3417C4.70185 5.80987 5.33726 6.07283 5.99977 6.07283C6.66227 6.07283 7.29768 5.80987 7.76643 5.3417L11.5914 1.51671C11.7466 1.36058 11.8338 1.14937 11.8338 0.929212C11.8338 0.709057 11.7466 0.497848 11.5914 0.341713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsibleDown);
export default __webpack_public_path__ + "static/media/collapsible_down.0f731d205a433c763ce96d58d23967e0.svg";
export { ForwardRef as ReactComponent };